export default {
  en: {
    actions: {
      edit: 'Edit',
      createUser: 'Create user',
      editUser: 'Edit user',
      removeUser: 'Remove user',
      createAnotherUser: 'Create another user',
      createRole: 'Create role',
      editRole: 'Edit role',
      createAnotherRole: 'Create another role',
      createArea: 'Create area',
      editArea: 'Edit area',
      createAnotherArea: 'Create another area',
    },
    sections: {
      users: 'Users',
      roles: 'Roles',
      areas: 'Areas',
    },
    messages: {
      firstUser:
        "Looks like you're the only one in your team right now!\nIf you want to add more team members, you can <1>create a user.</1>",
      userCreated: 'You created a new user!',
      deleteUserConfirmation:
        "Are you sure you want to delete this user? This action can't be undone.",
      deleteRoleConfirmation:
        "Are you sure you want to delete this role? This action can't be undone.",
      areaCreated: 'You have created a new area!',
      roleCreated: 'You created a new role!',
    },
    user: {
      name: 'Name',
      firstName: 'First name',
      lastName: 'Last name',
      role: 'Role',
      area: 'Area',
      email: 'Email',
      phone: 'Phone',
      lastSignInAt: 'Last log in date',
      accessToAllEvents: 'Access to all events',
      neverLoggedIn: 'Never',
    },
    area: {
      areaName: 'Area name',
      description: 'Description',
      events: 'Events',
      users: 'Users in this area',
      creationDate: 'Creation date',
    },
    forms: {
      firstNamePlaceholder: 'John',
      lastNamePlaceholder: 'Doe',
      emailPlaceholder: 'hello@eventtia.com',
      phonePlaceholder: '+1 123 456 7890',
      accessToAllEventsDescription:
        'If this option is not selected, the user will only have access to events they create or those assigned to them through an area.',
      areaNamePlaceholder: 'Art and science',
      roleNamePlaceholder: 'Ex: Event Manager',
    },
    roles: {
      roleName: 'Role name',
      rolePermissionDescription: 'Select the permissions for this role',
      users: 'Users in this role',
      date: 'Created on',
    },
    permissions: {
      allowedTo: 'Allowed to',
      actions: {
        index: 'Index',
        show: 'Show',
        create: 'Create',
        update: 'Update',
        destroy: 'Destroy',
      },
      moduleTypes: {
        attendeeTypes: 'Attendee types',
        attendees: 'Attendees',
        eventSettings: 'Event settings',
        events: 'Events',
        exportProcesses: 'Export processes',
        fields: 'Fields',
        notifications: 'Notifications',
        pricingTiers: 'Pricing tiers',
        speakers: 'Speakers',
        workshops: 'Workshops',
        notificationLanguages: 'Notification languages',
      },
    },
    addUsersModal: {
      addUsersToArea: 'Add users to this area',
      helperText:
        'Users you add will be able to use their permissions in events of this area.',
      addUsers: 'Add users',
      cancel: 'Cancel',
      inputPlaceholder: 'Min two characters',
      noResultsLabel: 'No users found',
      usersLabel: 'users',
      userAlreadyExists: 'User already exists in the area.',
    },
    table: {
      usersInThisArea: 'Users in this area',
      userInThisArea: 'User in this area',
      eventInThisArea: 'Event',
      eventsInThisArea: 'Events',
      eventDateFrom: 'From',
      eventDateTo: 'To',
    },
  },
};
